// src/pages/Finance.js
import React, { useEffect, useState } from "react";
import Reveal, { StaggerContainer, RevealChild } from "../components/Reveal";
import "../styles/Finance.css";
import heroBg from "../assets/reportbanner.jpg"; 

function Finance() {
  const [current, setCurrent] = useState([]);
  const [past, setPast] = useState([]);

  useEffect(() => {
    const fetchFinance = async () => {
      try {
        const res = await fetch("/api/finance");
        const data = await res.json();
        setCurrent(data.currentReports || []);
        setPast(data.pastReports || []);
      } catch (e) {
        console.error(e);
      }
    };
    fetchFinance();
  }, []);

  const getReport = (type) => current.find(r => r.type === type);
  const annual = getReport("annualReport");
  const income = getReport("incomeStatement");
  const balance = getReport("balanceSheet");

  return (
    <div className="finance-page">
      <div className="page-header" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="overlay"></div>
        <div className="container header-content">
          <Reveal>
            <h1>Financial Transparency</h1>
            <p>View our annual reports and financial statements.</p>
          </Reveal>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <Reveal>
            <div className="section-header">
              <h2>Current Reports</h2>
            </div>
          </Reveal>
          
          <StaggerContainer className="grid-3">
            <RevealChild className="card report-card">
              <div className="report-icon">📊</div>
              <h3>Annual Report</h3>
              <p>Comprehensive overview of our year.</p>
              {annual?.link ? (
                <a href={annual.link} target="_blank" rel="noreferrer" className="btn btn-primary btn-sm">
                  View {annual.fiscalyear}
                </a>
              ) : <span className="disabled">Not available</span>}
            </RevealChild>

            <RevealChild className="card report-card">
              <div className="report-icon">💰</div>
              <h3>Income Statement</h3>
              <p>Review our operational resources.</p>
              {income?.link ? (
                <a href={income.link} target="_blank" rel="noreferrer" className="btn btn-primary btn-sm">
                  View {income.fiscalyear}
                </a>
              ) : <span className="disabled">Not available</span>}
            </RevealChild>

            <RevealChild className="card report-card">
              <div className="report-icon">⚖️</div>
              <h3>Balance Sheet</h3>
              <p>Assets and financial position.</p>
              {balance?.link ? (
                <a href={balance.link} target="_blank" rel="noreferrer" className="btn btn-primary btn-sm">
                  View {balance.fiscalyear}
                </a>
              ) : <span className="disabled">Not available</span>}
            </RevealChild>
          </StaggerContainer>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <Reveal>
            <h2>Archive</h2>
            <p style={{marginBottom: "2rem"}}>Past financial documents and statements.</p>
            <div className="archive-list card">
              {past.length > 0 ? (
                <ul>
                  {past.map((p, i) => (
                    <li key={i}>
                      <a href={p.link} target="_blank" rel="noreferrer">{p.title}</a>
                    </li>
                  ))}
                </ul>
              ) : <p style={{padding: "2rem", textAlign: "center"}}>No archived reports found.</p>}
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}

export default Finance;